import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  instructorGet,
  organizationConnectionList,
  outgoingOrganizationConnectionDemandCreate,
  outgoingOrganizationConnectionDemandList,
} from '../store/action/instructor';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Avatar from 'react-avatar';
import { Link } from 'react-router-dom';
import { getFullPath, permissionTypes } from '../../utils';
import { AsyncSelect } from '../../components/Form';
import { useForm } from 'react-hook-form';
import OutgoingOrganizationConnectionDemandList from '../../components/OutgoingOrganizationConnectionDemandList';
import Loader from '../../components/Loader';
import OrganizationConnectionList from '../../components/organizationConnectionList';
import qs from 'query-string';
import DOMPurify from 'dompurify';

export default function InstructorSingle({ history }) {
  let { search, pathname } = history.location;
  const qps = qs.parse(search);
  const [queryParams, setQueryParams] = useState({
    orgConnectionPage: 1,
    orgDemandPage: 1,
    ...qps,
  });

  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);

  // original resource of
  let detailOfInstructor = useSelector(state => state.instructor.original);
  let listOfOutgoingOrganizationConnectionDemand = useSelector(
    state => state.instructor.outgoingOrganizationConnectionDemand.list
  );
  let detailOfOutgoingOrganizationConnectionDemand = useSelector(
    state => state.instructor.outgoingOrganizationConnectionDemand
  );
  let listOfOrganizationConnection = useSelector(state => state.instructor.organizationConnection.list);
  let detailOfOrganizationConnection = useSelector(state => state.instructor.organizationConnection);
  let showLoader =
    detailOfInstructor.isLoading ||
    listOfOutgoingOrganizationConnectionDemand.isLoading ||
    detailOfOutgoingOrganizationConnectionDemand.isLoading ||
    listOfOrganizationConnection.isLoading ||
    detailOfOrganizationConnection.isLoading;

  let isRenderedInstructor = detailOfInstructor.data && !detailOfInstructor.isLoading;
  let isRenderedOutgoingOrganizationConnectionDemand =
    listOfOutgoingOrganizationConnectionDemand.data && !listOfOutgoingOrganizationConnectionDemand.isLoading;
  let isRenderedOrganizationConnection = listOfOrganizationConnection.data && !listOfOrganizationConnection.isLoading;

  const dispatch = useDispatch();

  let { control, handleSubmit, setValue } = useForm();

  const handlePageChange = (page, name) => setQueryParams({ ...queryParams, [name]: page });

  function onSubmit(data) {
    let organizations_id = data.organizations_id?.map(item => item.value);
    dispatch(outgoingOrganizationConnectionDemandCreate({ organizations_id }));
  }

  useEffect(() => {
    dispatch(instructorGet());
    dispatch(organizationConnectionList({ page_size: 2 }));

    // eslint-disable-next-line
  }, []);

  //if change role in this page redirect to home
  useEffect(() => {
    if (selectedRole?.name !== permissionTypes.instructor) {
      history.push('/');
    }
  }, [selectedRole]);

  useEffect(() => {
    let paramsAPI = {};
    let paramsRouter = {};

    paramsAPI['page'] = queryParams.orgConnectionPage;
    if (queryParams.orgConnectionPage > 1) paramsRouter['orgConnectionPage'] = queryParams.orgConnectionPage;
    if (queryParams.orgDemandPage > 1) paramsRouter['orgDemandPage'] = queryParams.orgDemandPage;

    let paramsString = qs.stringify(paramsRouter);
    paramsString = !!paramsString ? `?${paramsString}` : '';
    history.push(`${pathname}${paramsString}`);

    dispatch(organizationConnectionList(paramsAPI));
    /* eslint-disable-next-line */
  }, [queryParams.orgConnectionPage]);

  useEffect(() => {
    let paramsAPI = { status__in: '1,3' };
    let paramsRouter = {};

    paramsAPI['page'] = queryParams.orgDemandPage;
    if (queryParams.orgDemandPage > 1) paramsRouter['orgDemandPage'] = queryParams.orgDemandPage;
    if (queryParams.orgConnectionPage > 1) paramsRouter['orgConnectionPage'] = queryParams.orgConnectionPage;

    let paramsString = qs.stringify(paramsRouter);
    paramsString = !!paramsString ? `?${paramsString}` : '';
    history.push(`${pathname}${paramsString}`);

    dispatch(outgoingOrganizationConnectionDemandList(paramsAPI));
  }, [detailOfOutgoingOrganizationConnectionDemand.data, listOfOrganizationConnection.data, queryParams.orgDemandPage]);

  return (
    <>
      <div className="kt-portlet p-3">
        <div className="kt-portlet__body pt-0">
          <Row>
            <Col xs={12} xl={4}>
              {isRenderedInstructor && (
                <Row>
                  <Col xs={12}>
                    <div className={'d-flex align-items-center'}>
                      <Avatar src={detailOfInstructor.data.profile_image} round />
                      <div className={'px-3'}>
                        <p>
                          نام ونام خانودگی:{' '}
                          {`${detailOfInstructor.data.given_name} ${detailOfInstructor.data.family_name}`}
                        </p>
                        <p>ایمیل: {detailOfInstructor.data.email}</p>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12}>
                    <p className={'p-3'}>
                      معرفی استاد:
                      <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(detailOfInstructor.data.bio) }} />
                    </p>
                  </Col>
                  <Col xs={12}>
                    <div>
                      <Link to={`/instructor/${detailOfInstructor.data.id}`}>
                        <Button>ویرایش اطلاعات</Button>
                      </Link>
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
            <Col xs={12} xl={8}>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className={'align-items-center mt-5 mt-xl-0'}>
                  <Col xs={8}>
                    <div>
                      <AsyncSelect
                        control={control}
                        name={'organizations_id'}
                        isMulti
                        optionPattern={{ label: 'name', value: 'id' }}
                        apiPath={'/manage/instructor/organizations/all/'}
                        queryParam={'search'}
                        label={'انتخاب سازمان'}
                      />
                    </div>
                  </Col>
                  <Col xs={4}>
                    <div className={'d-flex justify-content-end'}>
                      <Button type={'submit'}>ارسال درخواست همکاری</Button>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {isRenderedOrganizationConnection && (
                      <OrganizationConnectionList
                        organizationConnectionList={listOfOrganizationConnection}
                        count={listOfOrganizationConnection.count}
                        onPageChange={handlePageChange}
                        pageParamName={'orgConnectionPage'}
                        currentPage={parseInt(queryParams.orgConnectionPage)}
                        title={'سازمان های همکار'}
                      />
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {isRenderedOutgoingOrganizationConnectionDemand && (
                      <OutgoingOrganizationConnectionDemandList
                        outgoingOrganizationConnectionDemandList={listOfOutgoingOrganizationConnectionDemand}
                        count={listOfOutgoingOrganizationConnectionDemand.count}
                        onPageChange={handlePageChange}
                        pageParamName={'orgDemandPage'}
                        currentPage={parseInt(queryParams.orgDemandPage)}
                        title={'درخواست های همکاری'}
                      />
                    )}
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
      <Loader visible={showLoader} />
    </>
  );
}
